import styled from 'styled-components';
import FourCut1 from '../../assets/images/4cut_1.png';
import FourCut2 from '../../assets/images/4cut_2.png';
import FourCut3 from '../../assets/images/4cut_3.png';
import FourCut4 from '../../assets/images/4cut_4.png';

const FourCut = () => {
  return (
    <section>
      <h2 className="a11y-hidden">영준이와 유진이의 인생네컷</h2>
      <StyledUl>
        <li>
          <img src={FourCut1} alt="" />
        </li>
        <li>
          <img src={FourCut2} alt="" />
        </li>
        <li>
          <img src={FourCut3} alt="" />
        </li>
        <li>
          <img src={FourCut4} alt="" />
        </li>
      </StyledUl>
    </section>
  );
};

const StyledUl = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export default FourCut;
